export default "__VITE_ASSET__CTpAMqQF__"